import Joi from "joi";

const VALIDATION = "dashboard.groupList.validation";

/** The form of a group, to create or change it. Its messages are translation keys, translated where they are shown. */
export const groupSchema = Joi.object({
  group_name: Joi.string()
    .trim()
    .min(2)
    .max(30)
    .required()
    .messages({
      "any.required": `${VALIDATION}.nameRequired`,
      "string.empty": `${VALIDATION}.nameRequired`,
      "string.min": `${VALIDATION}.nameLength`,
      "string.max": `${VALIDATION}.nameLength`,
    }),
  group_description: Joi.string()
    .trim()
    .min(2)
    .max(250)
    .required()
    .messages({
      "any.required": `${VALIDATION}.descriptionRequired`,
      "string.empty": `${VALIDATION}.descriptionRequired`,
      "string.min": `${VALIDATION}.descriptionLength`,
      "string.max": `${VALIDATION}.descriptionLength`,
    }),
});
